import { AxiosProgressEvent } from 'axios'

export function calculateUpdateProgress(event: AxiosProgressEvent): number {
  const { loaded = 0, total = 0 } = event
  const progress = Math.round((loaded * 100) / total)

  return progress
}
